$(function() {

    const tilesPerSq = tileConfig.tilesPerSq;
    const tilesPerPack = tileConfig.tilesPerPack;
    const tileWidth = tileConfig.tileWidth;
    const tileHeight = tileConfig.tileHeight;

    $('.thb-product-detail quantity-selector').hide();

    $('#tileCalculator').on('click', function (e) {
        e.stopPropagation();
    });

    $('#tileCalcLink').on('click', function(e) {
        $('#tileCalcInputs').slideToggle();
        e.stopPropagation();
        return false;
    });

    $('#extrawaste').on('change', function () {
        calculateQty();
        $('#qty').focus();
    });

    let $widthInput = $('#tileCalcWidth');
    let $heightInput = $('#tileCalcHeight');
    let $total = $('#tileCalcTotal');
    let $qty = $('#qty');
    let productPricePerTile = $("meta[property='og:price:amount']").attr("content");
    let wastePercentage = 10;
    var extraArea = 0;

    // Watch for changes to the amount required
    $widthInput.on('keyup input', function () {
        calculateArea();
        calculateQty();
    });

    $heightInput.on('keyup input', function () {
        calculateArea();
        calculateQty();
    });

    $qty.on('keyup input', function () {
        clearOtherFields();
        updateArea();
        updateSimpleTotal();
    });

    $total.on('keyup input', function () {
        calculateQty();
    });

    function calculateArea() {
        let width = Number($widthInput.val()).toFixed(2);
        let height = Number($heightInput.val()).toFixed(2);
        $('#tileCalcTotalLabel').addClass('active');

        if (!isNaN(width) && !isNaN(height)) {
            // Calculate total m2
            let totalArea = (height * width) / 10000; // Total Area

            if($('input[name="extrawaste"]').is(':checked')){
                extraArea = totalArea / wastePercentage;
            } else {
                extraArea = 0;
            }

            totalArea = totalArea + extraArea; // Total Area with Extra

            // Calculate total qty required
            let totalM2 = (tilesPerSq * totalArea) / tilesPerPack;

            // Update totals
            $('#tileCalcTotal').val(Number(totalArea).toFixed(2));

            // Update area
            $('#tileCalcAreaTotal').html(Number(height * width));
            $('#qty').val(Math.ceil(totalM2));
            $('quantity-selector .qty').val(Math.ceil(totalM2));

        } else {
            // Reset when NaN supplied
            $('#tileCalcTotal').val(0);
            $('#qty').val(0);
            $('quantity-selector .qty').val(0);
        }
    }

    function updateArea() {

        let totalArea = ($qty.val() * tilesPerPack) / tilesPerSq;
        $('#tileCalcTotal').val(Number(totalArea).toFixed(2));

        let extraArea = 0;
        if($('input[name="extrawaste"]').is(':checked')){
            extraArea = totalArea / wastePercentage;
        }
        totalArea = totalArea + extraArea; // Total Area with Extra
        if(extraArea != 0) {
            $('#wastageSQM').html(' ('+Number(totalArea).toFixed(2)+'m<sup>2</sup>)');
        } else {
            $('#wastageSQM').html('');
        }

        $('quantity-selector .qty').val($('#qty').val());

        // move label away from displayed value:
        $('#tileCalcTotalLabel').addClass('active');
    }

    function calculateQty() {
        let totalArea = Number($total.val());

        if (!isNaN(totalArea)) {

            if($('input[name="extrawaste"]').is(':checked')){
                extraArea = totalArea / wastePercentage;
            } else {
                extraArea = 0;
            }

            totalArea = totalArea + extraArea; // Total Area with Extra

            // Calculate total qty required
            let totalM2 = (tilesPerSq * totalArea) / tilesPerPack;
            totalM2 = Math.max(1, totalM2);
            if(extraArea != 0) {
                $('#wastageSQM').html(' ('+Number(totalArea).toFixed(2)+'m<sup>2</sup>)');
            } else {
                $('#wastageSQM').html('');
            }
            $('#qty').val(Math.ceil(totalM2));
            $('quantity-selector .qty').val(Math.ceil(totalM2));

            let quotedCost = Math.ceil(totalM2) * productPricePerTile;
            $('#tiles-total-price').html('£' + quotedCost.toFixed(2));
        } else {
            $('#qty').val(0);
            $('quantity-selector .qty').val(0);
        }
    }

    function clearOtherFields() {
        $heightInput.val('');
        $widthInput.val('');
        $total.val('');
    }

    function updateSimpleTotal() {
        let exactCost = Math.ceil($qty.val()) * productPricePerTile;
        $('#tiles-total-price').html('£' + exactCost.toFixed(2));
    }
});